import { QuestionaireType } from "./enums";


export const SurveyQuestionTypes: any[] = [
    { span: 7, label: QuestionaireType.Text },
    { span: 7, label: QuestionaireType.Media },
    { span: 7, label: QuestionaireType.File },
    { span: 7, label: QuestionaireType.Name },
    { span: 7, label: QuestionaireType.Phone },
    { span: 7, label: QuestionaireType.Email },
    { span: 9, label: QuestionaireType.DateTime },
    { span: 6, label: QuestionaireType.Date },
    { span: 7, label: QuestionaireType.Time },
    { span: 5, label: QuestionaireType.Bar },
    { span: 8, label: QuestionaireType.Number },
    { span: 9, label: QuestionaireType.Currency },
    { span: 7, label: QuestionaireType.ThreeButton },
    { span: 6, label: QuestionaireType.YesNo },
    { span: 9, label: QuestionaireType.MultipleChoice },
    { span: 6, label: QuestionaireType.Tag },
    { span: 6, label: QuestionaireType.TagNot },
    { span: 7, label: QuestionaireType.Location },
    { span: 9, label: QuestionaireType.GPS },
    { span: 6, label: QuestionaireType.Capture },
    { span: 7, label: QuestionaireType.Signature },
  ];


export const SurveyTypes: any[] = [
    ...SurveyQuestionTypes,
    { span: 6, label: QuestionaireType.Project },
    { span: 6, label: QuestionaireType.Search },
    { span: 10, label: QuestionaireType.IncidentLocation },
    { span: 6, label: QuestionaireType.Event },
    { span: 6, label: QuestionaireType.FixedAsset },
    { span: 6, label: QuestionaireType.Responder },
    { span: 7, label: QuestionaireType.TaskPicker },
    { span: 9, label: QuestionaireType.Customer },
    { span: 6, label: QuestionaireType.DispatchType },
  ];